/*
 * Addresses of the analysis workbench's thermal mode, for the places that open
 * a thermal capture from their own page: the dossier's and Home's Thermal
 * strip (components/thermal/ThermalStrip.js) and an experiment's Thermal &
 * Metabolic tab (pages/experiments/ThermalTab.js). A light module: it loads
 * nothing of the workbench (docs/ANALYSIS_WORKBENCH.md section 8).
 *
 *   thermalPath({capture, isolate, experiment, back})
 *     capture     the capture on the stage
 *     isolate     each new ROI tied to this isolate; its captures listed first
 *     experiment  the experiment's ROI template and its seed for the capture
 *     back        where the workbench's Back goes (pages/tools/AnalysisWorkbench.js
 *                 takes an in-app path only): the page the person was on
 */
export const THERMAL_MODE_PATH = '/tools/analysis';

export function thermalPath({ capture = null, isolate = null, experiment = null, back = null } = {}) {
  const query = new URLSearchParams({ mode: 'thermal' });
  if (isolate) query.set('isolate', isolate);
  if (capture) query.set('capture', capture);
  if (experiment) query.set('experiment', experiment);
  if (back) query.set('back', back);
  return `${THERMAL_MODE_PATH}?${query}`;
}

/** The address a page is at now (path, query, hash), for `back`. */
export const hereOf = location => `${location?.pathname || '/'}${location?.search || ''}${location?.hash || ''}`;
